import { NumberBar } from "phaser3-rex-plugins/templates/ui/ui-components";
import Game from "../Game";
import GameCore from "../GameCore";
import { GAP, TOP_MARGIN, UI_PADDING } from "./MainUI";
import { TEXT_STYLES } from "../../../utils/FontManager";
import { DEFAULT_SCALE } from "../../consts/UI";
window["Percent"] = Phaser.Math.Percent;

const scaleRatio = DEFAULT_SCALE;
// const scaleRatio = Math.min(2, devicePixelRatio)
export const XP_BAR_HEIGHT = 10 * scaleRatio;

export default class PlayerUI {
  scene: Phaser.Scene;
  xpBar: NumberBar;
  hpBarOffset: any;
  hpBarHeight: number;
  hpBarWidth: number;
  hpBar: any;
  constructor(scene: Phaser.Scene) {
    this.scene = scene;
    this.hpBarOffset = new Phaser.Math.Vector2(-25, 26);
    this.hpBarHeight = 4;
    this.hpBarWidth = 50;
    this.hpBar = scene.add.graphics().setScrollFactor(0);
    this.Init();
  }
  Init() {
    // Calculate actual width (respecting max-width)
    const width = this.scene.renderer.width - UI_PADDING * 2;

    this.xpBar = this.scene.rexUI.add
      .numberBar({
        anchor: {
          top: `top+${TOP_MARGIN + GAP}`,
          left: `left+${UI_PADDING}`,
          right: `right+${UI_PADDING}`,
        },
        width: width,
        height: XP_BAR_HEIGHT,
        slider: {
          track: this.scene.rexUI.add.roundRectangle(
            0,
            0,
            0,
            XP_BAR_HEIGHT,
            5,
            0xffffff
          ),
          indicator: this.scene.rexUI.add.roundRectangle(
            0,
            0,
            0,
            XP_BAR_HEIGHT,
            5,
            0x248bda
          ),
          easeValue: { duration: 250 },
        },
        text: this.scene.add
          .text(0, 0, "LV 1", {
            ...TEXT_STYLES.HEADER,
            fontSize: `${10 * scaleRatio}px`,
          })
          .setFixedSize(UI_PADDING * 2, 0),
        space: {
          left: UI_PADDING,
          right: UI_PADDING,
          top: 2 * scaleRatio,
          bottom: 2 * scaleRatio,

          icon: XP_BAR_HEIGHT,
          slider: XP_BAR_HEIGHT,
        },
      })
      .setScrollFactor(0)
      .setDepth(GameCore.ZInGameUI)
      .layout();
  }
  Update() {
    this.UpdateXpBar();
    this.UpdateHpBar();
  }

  UpdatePlayerLevel() {
    this.xpBar.setText(`LV ${Game.Core.Player.level}`);
  }

  UpdateXpBar() {
    this.xpBar.easeValueTo(
      Game.Core.Player.xp,
      Game.Core.LevelUpFactory.previousXpRequiredToLevelUp,
      Game.Core.LevelUpFactory.xpRequiredToLevelUp
    );
  }

  UpdateHpBar() {
    this.hpBar.clear();
    const hpValue = Game.Core.Player.hp / Game.Core.Player.maxHp;
    // hpBar BG
    this.hpBar.fillStyle(0x000000, 1);
    this.hpBar.fillRect(
      this.hpBarX,
      this.hpBarY,
      this.hpBarWidth,
      this.hpBarHeight
    );
    // value
    this.hpBar.fillStyle(0xff0000, 1);
    this.hpBar.fillRect(
      this.hpBarX,
      this.hpBarY,
      this.hpBarWidth * hpValue,
      this.hpBarHeight
    );
  }

  get hpBarX() {
    return 0.5 * this.scene.renderer.width + this.hpBarOffset.x;
  }

  get hpBarY() {
    return 0.5 * this.scene.renderer.height + this.hpBarOffset.y;
  }
}
